import { createSlideIcon, type IconProps } from '../SlideTypeIcon';
const DEFAULT_COLOR = 'var(--palette-gray-800)';

const Icon24x24 = ({ textColor = DEFAULT_COLOR }: IconProps) => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.7143 15.2857H15.2857V16.7143H16.7143V15.2857ZM19 13V19H13V13H19Z"
      fill={textColor}
    />
    <path d="M11 13H5V19H11V13Z" fill={textColor} />
    <path d="M19 5H13V11H19V5Z" fill={textColor} />
    <path d="M11 5H5V11H11V5Z" fill={textColor} />
  </>
);

const Icon32x32 = ({ textColor = DEFAULT_COLOR }: IconProps) => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.12 19.52H19.52V21.12H21.12V19.52ZM23.68 16.96V23.68H16.96V16.96H23.68Z"
      fill={textColor}
    />
    <path d="M15.0401 16.96H8.32007V23.68H15.0401V16.96Z" fill={textColor} />
    <path d="M23.68 8.31982H16.96V15.0398H23.68V8.31982Z" fill={textColor} />
    <path
      d="M15.0401 8.31982H8.32007V15.0398H15.0401V8.31982Z"
      fill={textColor}
    />
  </>
);

export const InstructionsIcon = createSlideIcon(Icon24x24, Icon32x32);
